export * from './admin-bitf.config';
